/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if(boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.filterTreeVerticalStyle = "style-off-canvas";
}

if(boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.filterAvoidStickyHeader = ['header, .strapLine']; //Please modify this array
}

if (boostSDAppConfig?.themeSettings) {
  boostSDAppConfig.themeSettings.cart.cartStyle = 'none';
}

const customize = {
  updateProductItemGrid: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Add extra badges #225242",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Start customization--------------------------------------------
            let productData = element.getParams().props.product;
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector(
              '[data-product-id="' + productId + '"]'
            );
            if (productItem) {
            // Start adding label - card-product.liquid
              const topImgRowLeft = productItem.querySelector(".boost-sd__product-image-column--in-top.boost-sd__product-image-column--left");
              let customLabels = "";

              const as_created_at = new Date(productData.created_at);
              const as_now = new Date();
              const as_difference = Math.floor((as_now - as_created_at) / (1000 * 60 * 60 * 24));

              if (as_difference < 30) {
              customLabels += `
                      <div class="card__badge bottom left">
                          <span class="badge badge--bottom-left">NOUVEAU</span>
                      </div>
                  `;
              }
              // Add sale label
              if (productData?.percent_sale_min > 0) {
                customLabels += `<span class="boost-sd-percent-sale-badge">-${productData.percent_sale_min}%</span>`;
              }
              
              let customLabelsHTML = customLabels ? `<div class="product-badges"><div class="product-badges__wrapper">${customLabels}</div>`: "";
              if (topImgRowLeft && customLabelsHTML) {
                topImgRowLeft.innerHTML = customLabelsHTML;
              }
              // End adding label

              // Start adding color list - price.liquid
              const as_variants = productData.variants;
              let as_option_count = findOption(productData.options_with_values, ['Couleur', 'Motif', 'Style'])?.values?.length;

              if (as_option_count > 0 && !productItem.querySelector('.as-coloris-count') && productItem.querySelector('.boost-sd__product-price-wrapper')) {
                const optionCountHtml = `<div class="as-coloris-count" style="display:inline-flex">
                                        <span>
                                          |
                                          <strong>${as_option_count}</strong>
                                          coloris
                                        </span>
                                      </div>`
                productItem.querySelector('.boost-sd__product-price-wrapper').insertAdjacentHTML('beforeend', optionCountHtml);
              }
              // End adding color list
            }
            // End-------------------------------------------------------------
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);

function findOption(options, targetOptions) {
    return options.find(option => targetOptions.includes(option.label));
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
  registry.useComponentPlugin('ProductTitle', {
    name: 'Change product title to H3',
    enabled: true,
    apply: () => ({
      render(elementModel, currentRenderElement) {
        try {
		  // Get the CSS styling data from props and store them in elmStyles object
          const {color, fontFamily, fontSize, fontStyle, fontWeight, textTransform, title} = currentRenderElement.props;
          const elmStyles = {
            color,
            fontFamily,
            fontSize,
            fontStyle,
            fontWeight,
            textTransform,
          }
          const titleHTML = `<h3 class="boost-sd__product-title">${title}</h3>`;
          return createElementFromHTML(titleHTML.trim(), elmStyles); // Return new title elm with h3 and the styles defined in elmStyles
        } catch (error) {
          console.warn(error);
          return currentRenderElement; // Fallback -> return the original elm if there is an error
        }
      },
    }),
  });
});

function createElementFromHTML(htmlString, styles) {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  
  // Add styles
  for (const value in styles) {
    if (styles[value] === undefined) {
      delete styles[value];
    }
  }
  Object.assign(div.firstChild.style, styles);
  
  return div.firstChild;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
      componentRegistry.useModulePlugin('CartAPI', {
         name: 'Integrate theme cart',
         apply(builder) {
            builder.on('methodFulfilled', 'addToCart', async (payload) => {
              if (payload.result.ok) {
               fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((response) => response.text())
                  .then((responseText) => {
                     const cartDrawerElm = document.querySelector('cart-drawer');
                     const html = new DOMParser().parseFromString(responseText, 'text/html');
                     const newCartDrawerHTML = html.querySelector('#CartDrawer').innerHTML;
                     cartDrawerElm.querySelector('#CartDrawer').innerHTML = newCartDrawerHTML;
                     cartDrawerElm.classList.remove('is-empty');
                     cartDrawerElm.open();
                  });
              }
            });
         },
      });
   }
]);